import { Outlet } from 'react-router';
import { StudioSidebar } from './studio-sidebar';
import { TrustFooter } from './trust-footer';

export function StudioShell() {
  return (
    <div className="flex min-h-[100dvh] flex-col md:h-[100dvh]">
      <div className="flex flex-1 flex-col md:min-h-0 md:flex-row">
        <StudioSidebar />
        <main className="relative flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <TrustFooter />
    </div>
  );
}
